export default {
  // Table Headers
  headers: {
    // Common headers
    result: "Result",
    results: "Results",
    current: "Current",
    test: "Test",
    flagText: "Flag",
    flags: "Flags",
    refRange: "Ref. Range",
    units: "Units",
    resultTime: "Date / Time",
    history: "History",
    actions: "Actions",
    visit_id: "Visit ID",
    barcode: "Barcode",
    sample_type: "Sample Type",
    total_results: "Results",
    sample_category: "Category",
    collection_time: "Collected",
    instrument: "Instrument",
    disk_rack: "Disk/Rack",
    position: "Position",
    sample_number: "Sample No.",
    sets_count: "Sets",
    pending_results: "Pending",
    approved_results: "Approved",
  },

  no_data: "No data available",
  items_per_page: "Items per page:",
  all: "All",
  clearFilters: "Clear filters",
  unknown_location: "Unknown location",

  toolbar: {
    refresh: "Refresh",
    email: "Send by Email",
    emailAction: "Email",
    pdf: "Download PDF",
    pdfAction: "PDF",
  },
};
